"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.denial = undefined;

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// For saved for later success just update status to saved and dispatch event in under review compoent to fire call to get new active
//
var denial = exports.denial = function denial() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var nextState = {};

    switch (action.type) {
        case actionTypes.DENIAL_REASONS_SUCCESS:
            nextState = action.response;
            break;

        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};